import React from 'react';
import Image from 'next/image';
import Tooltip from '@mui/material/Tooltip';
import { useClintMediaQuery } from '@/utils/hooks';
import {
  EDUCATION_MAP,
  EDUCATION_NONE,
  WORK_EXPERIENCE_MAP,
  WORK_EXPERIENCE_NONE,
} from '@/constants/job-title';
import HelpIcon from '@/assets/job-title/help.svg';

const BarYAxisLabel = (props: {
  chartData: Record<string, unknown>[];
  jobTitleName?: string;
}) => {
  const { chartData, jobTitleName } = props;
  const isMobile = useClintMediaQuery();

  return (
    <div className="flex flex-col text-sm w-14 shrink-0 pb-7">
      {chartData.map((item: any, index) => {
        const label = item['label'];
        if (
          label === WORK_EXPERIENCE_MAP[WORK_EXPERIENCE_NONE] ||
          label === EDUCATION_MAP[EDUCATION_NONE]
        ) {
          return (
            <div
              key={index}
              className="relative whitespace-nowrap h-10 leading-10"
            >
              {!isMobile && (
                <Tooltip
                  className="hidden tablet:block"
                  title={
                    <p className="text-sm leading-5.5">
                      指对
                      {label === EDUCATION_MAP[EDUCATION_NONE]
                        ? '学历'
                        : '工作经验年限'}
                      没有明确要求{jobTitleName}的平均薪资区间
                    </p>
                  }
                  disableTouchListener={true}
                  placement="bottom-start"
                  PopperProps={{
                    sx: {
                      '.MuiTooltip-tooltip': {
                        background: 'rgba(0, 0, 0, 0.7)',
                        borderRadius: '4px',
                        maxWidth: 'fit-content',
                        padding: '8px 20px',
                        marginTop: '4px !important',
                      },
                    },
                  }}
                >
                  <div className="h-5 w-5 absolute top-1/2 -translate-y-1/2 -left-7 cursor-pointer">
                    <Image
                      src={HelpIcon}
                      alt="tooltip icon"
                      className="opacity-40"
                    />
                  </div>
                </Tooltip>
              )}
              {label}
            </div>
          );
        }
        return (
          <div key={index} className="h-10 leading-10">
            {label}
          </div>
        );
      })}
    </div>
  );
};

export default BarYAxisLabel;
